import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

const BudgetDuringInspectionSectionGridItemDetails = ({ dataCy, labelId, value }) => (
  <div className="flex flex-col w-full" data-cy={dataCy}>
    <div className="font-bold">
      <FormattedMessage id={labelId} />
    </div>
    <div className="whitespace-pre-wrap">
      {value}
    </div>
  </div>
);

BudgetDuringInspectionSectionGridItemDetails.propTypes = {
  dataCy: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default BudgetDuringInspectionSectionGridItemDetails;
